/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agenda_Source_InfoInputs */



/**
* | output |
* | --- |
* | "Where this agenda comes from" |
*
* @param {Agenda_Source_InfoInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const agenda_source_info = /** @type {((inputs?: Agenda_Source_InfoInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agenda_Source_InfoInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Waar deze agenda vandaan komt")
	if (locale === "fr") return /** @type {LocalizedString} */ ("D'où vient cet agenda")
	return /** @type {LocalizedString} */ ("Where this agenda comes from")
});